module.exports = __webpack_public_path__ + "ac81f7d379d01e17c7eaaf743ca77528.pdf";